import { styled } from 'styled-components';
import React from 'react';
import ServicesFilter from '../../components/ServicesFilter/ServicesFilter';
import { HeaderServiceFilter } from '@hud/web-components/Filters/HeaderServiceFilter';
import { useUserPreferences } from '../../hooks/useUserPreferences';
import { HudIcon, IconType } from '@hud/web-components/Icons/HudIcons';
import { heading2 } from '@hud/web-components/DesignSystem/Typography';

type OverviewPageHeaderActionsProps = {
  services: number[];
  setServices: (services: number[]) => void;
};

export default function OverviewPageHeader({
  services,
  setServices,
}: OverviewPageHeaderActionsProps) {
  const { userPreferredServices } = useUserPreferences();
  const isMyServices =
    services.length === userPreferredServices?.length &&
    userPreferredServices.length > 0 &&
    services.every((service) => userPreferredServices.includes(service));

  const icon = isMyServices ? 'designSystem.starOutline' : `designSystem.service`;
  return (
    <Container>
      <span>Overview</span>
      <span className="separator"> / </span>
      <HudIcon icon={icon as IconType} size="20px" />
      <ServicesFilter
        userPreferredServices={userPreferredServices ?? []}
        filteredServices={services}
        onFilteredServicesChange={(newFilteredServices) =>
          setServices(newFilteredServices)
        }
        handleFilterChange={() => {}} // noop since this filter is always 'active'
        multiSelectFilterElement={HeaderServiceFilter}
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  ${heading2};
  gap: var(--space-50);

  .separator {
    color: var(--text-standard-secondary);
  }

  > svg path {
    stroke: var(--text-primary);
  }
`;
